import { render, staticRenderFns } from "./list_schools.vue?vue&type=template&id=9b13a5c8&lang=true&"
import script from "./list_schools.vue?vue&type=script&lang=js&"
export * from "./list_schools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports